import { render, staticRenderFns } from "./kendo-grid.vue?vue&type=template&id=66599284&scoped=true"
import script from "./kendo-grid.vue?vue&type=script&lang=js"
export * from "./kendo-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66599284",
  null
  
)

export default component.exports